import React, { useState } from "react";
import "../styles/global.css";
import { Search, Clear } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";

const SearchAutocomplete = ({ products }) => {
  const navigate = useNavigate();
  const [localSearchTerm, setLocalSearchTerm] = useState("");
  const [isSearchEnabled, setIsSearchEnabled] = useState(false);

  // Filter products based on the search term.
  // Make sure to check on properties (product_name and brand_name) and handle cases where these might be undefined.
  const filteredProducts =
    localSearchTerm.length >= 2
      ? products.filter((product) => {
        const lowerTerm = localSearchTerm.toLowerCase();
        return (
          (product.product_name && product.product_name.toLowerCase().includes(lowerTerm)) ||
          (product.brand_name && product.brand_name.toLowerCase().includes(lowerTerm))
        );
      })
      : [];

  // Update search term and enable search if 2 or more characters are entered.
  const handleInputChange = (e) => {
    const term = e.target.value;
    setLocalSearchTerm(term);
    setIsSearchEnabled(term.length >= 2);
  };

  //
  const createSlug = (term) => {
    return term
      .toLowerCase()
      .trim()
      .replace(/\s+/g, "-")
      .replace(/[^\w-]+/g, "");
  };

  //
  const handleSubmit = (e) => {
    e.preventDefault();
    //
    if (localSearchTerm.length >= 2 && filteredProducts.length > 0) {
      navigate(`/search/${createSlug(localSearchTerm)}`);
      clearSearch();
    }
  };

  // Clear the search input.
  const clearSearch = () => {
    setLocalSearchTerm("");
    setIsSearchEnabled(false);
  };

  return (
    <div style={styles.search.container}>
      <form style={styles.search.inputFieldContainer} onSubmit={handleSubmit}>
        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            padding: "10px 10px 0px 10px",
            position: "relative",
          }}
        >
          {/* Search Icon */}
          <div
            style={{
              position: "absolute",
              left: 24,
              top: 0,
              bottom: 0,
              justifyContent: "center",
              alignContent: "center",
              paddingTop: 7,
            }}
          >
            <Search style={{ fontSize: 16, color: "gray" }} />
          </div>
          {/* Search Input */}
          <input
            type="search"
            placeholder="Search Fullproof"
            style={styles.search.inputField}
            value={localSearchTerm}
            onChange={handleInputChange}
            onBlur={() => { }}
            inputMode="search"
            enterKeyHint="search"
          />
          {localSearchTerm && localSearchTerm.length > 0 && (
            <IconButton
              onClick={clearSearch}
              style={{
                position: "absolute",
                right: 20,
                top: 0,
                bottom: 0,
                padding: 0,
                color: "rgba(0, 0, 0, 0.54)",
              }}
            >
              <Clear style={{ fontSize: 16 }} />
            </IconButton>
          )}
          {/* Dropdown Results */}
          {isSearchEnabled && localSearchTerm && (
            <div
              style={{
                position: "absolute",
                top: "110%",
                left: 0,
                right: 0,
                backgroundColor: "white",
                border: "1px solid #dadada",
                maxHeight: "300px",
                overflowY: "auto",
                zIndex: 1000,
                margin: "0px 10px",
                borderRadius: "8px",
              }}
            >
              {filteredProducts.length > 0 ? (
                filteredProducts.map((product) => (
                  <div
                    key={product.product_id}
                    style={{
                      padding: "10px",
                      borderBottom: "1px solid #f0f0f0",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      // navigate
                      navigate(`/Listing/${product.seller_product_id}`);
                      console.log("Selected Product:", product);
                      clearSearch();
                    }}
                  >
                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                      <div>
                        <img
                          src={product?.images && product.images.length > 0 ? product.images[0] : "/images/no_product_image.png"}
                          alt={product.product_name}
                          style={{ width: "40px", height: "40px", marginRight: "10px" }}
                        />
                      </div>
                      <div>
                        <div style={{ fontWeight: "bold" }}>{product.product_name}</div>
                        <div style={{ fontSize: "12px", color: "#888" }}>{product.brand_name}</div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div style={{ padding: "10px" }}>No results found</div>
              )}
            </div>
          )}
        </div>
      </form>
    </div>
  );
};

const styles = {
  search: {
    container: {
      marginTop: "25px",
      flexDirection: "row",
      display: "flex",
      padding: "0px 10px",
    },
    inputFieldContainer: {
      display: "flex",
      width: "100%",
      height: "70px",
      borderRadius: "0px",
      backgroundColor: "white",
      padding: "10px 0px",
    },
    inputField: {
      width: "100%",
      border: "none",
      height: "100%",
      outline: "none",
      fontSize: "14px",
      borderRadius: "50px",
      backgroundColor: "white",
      paddingLeft: "35px",
      border: "1px solid #dadada",
    },
  },
  searchButtonContainer: {},
  searchButton: {
    button: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
    },
    enabled: {
      backgroundColor: "black",
      color: "white",
      border: "none",
      height: "100%",
      cursor: "pointer",
      width: "100%",
      padding: "0 10px 0 15px",
    },
    disabled: {
      backgroundColor: "gray",
      color: "white",
      border: "none",
      height: "100%",
      cursor: "not-allowed",
      width: "100%",
      padding: "0 10px 0 15px",
    },
  },
  listItemContainer: {
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
    margin: "5px 0",
    cursor: "pointer",
  },
};

export default SearchAutocomplete;
